module.exports = __webpack_public_path__ + "static/media/custom-photo.3ad1eb9c.png";